import { z } from 'zod';
import { Timestamp } from 'firebase/firestore';

export const PaintingStatusSchema = z.enum(['available', 'sold']);

export const PaintingSchema = z.object({
  id: z.string(),
  title: z.string(),
  style: z.array(z.string()).min(1),
  height: z.number(),
  width: z.number(),
  category: z.array(z.string()),
  imageUrl: z.string().url(),
  // Optional: older/edge-case entries may not have one. Never make this
  // required — a single doc missing it would break parsing for every
  // painting in the gallery, not just that one (see Phase 5 postmortem).
  phash: z.string().optional(),
  // The photo's own pixel dimensions, distinct from height/width above
  // (the physical painting's size in inches) — lets the gallery grid
  // reserve each card's real layout space up front instead of guessing
  // from the painting's physical proportions, which often don't match how
  // the photo itself is framed. Optional for the same reason as phash.
  imageWidth: z.number().optional(),
  imageHeight: z.number().optional(),
  status: PaintingStatusSchema,
  createdAt: z.instanceof(Timestamp),
});
